<template>
  <div>
    <marquee-text></marquee-text>
    <b-row class="match-height" align-h="center">
      <b-col md="3">
        <ref-tvl-card />
      </b-col>
      <b-col md="7">
        <ref-tvl-chart />
      </b-col>
    </b-row>
    <b-row class="match-height" align-h="center">
      <b-col md="2">
        <statistic-card-vertical
          color="info"
          icon="DollarSignIcon"
          :statistic="`$${dFormatter(swapVolume)}`"
          statistic-title="Volume Last 24h"
        />
      </b-col>
      <b-col md="2">
        <statistic-card-vertical
          color="info"
          icon="UserPlusIcon"
          :statistic="`${uniqueTraders}`"
          statistic-title="Traders Last 24h"
        />
      </b-col>
      <b-col md="2">
        <statistic-card-vertical
          color="info"
          icon="RefreshCwIcon"
          :statistic="`${uniqueSwaps}`"
          statistic-title="Swaps Last 24h"
        />
      </b-col>
      <b-col md="2">
        <statistic-card-vertical
          color="info"
          icon="LockIcon"
          :statistic="`${refStaked}`"
          statistic-title="$REF Staked"
        />
      </b-col>
      <b-col md="2">
        <statistic-card-vertical
          color="info"
          icon="Minimize2Icon"
          :statistic="`$${refRate}`"
          statistic-title="$REF/$xREF Rate"
        />
      </b-col>
      <b-col md="6">
        <ref-traffic-chart />
      </b-col>
      <b-col md="6">
        <ref-volume-chart />
      </b-col>
      <b-col md="5">
        <ref-top-pairs-chart />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import { dFormatter } from '@/@core/utils/filter'
import axios from 'axios'
import MarqueeText from '@/layouts/components/PricesTicker.vue'
import RefTrafficChart from './charts/RefTrafficChart.vue'
import RefTvlCard from './charts/RefTVLCard.vue'
import StatisticCardVertical from '@core/components/statistics-cards/StatisticCardVertical.vue'
import RefTvlChart from './charts/RefTVLChart.vue'
import RefVolumeChart from './charts/RefVolumeChart.vue'
import RefTopPairsChart from './charts/RefTopPairsChart.vue'

export default {
  components: {
    BRow,
    BCol,

    MarqueeText,
    RefTrafficChart,
    RefTvlCard,
    StatisticCardVertical,
    RefTvlChart,
    RefVolumeChart,
    RefTopPairsChart
  },
  data() {
    return {
      uniqueTraders: 0,
      uniqueSwaps: 0,
      refStaked: 0,
      refRate: 0,
      swapVolume: 0,
    }
  },
  methods: {
    dFormatter,
  },
  mounted() {
    axios.get('https://node-api.flipsidecrypto.com/api/v2/queries/697bee1a-a9ce-4a7c-9f06-5e39025e28bf/data/latest')
    .then(response => {
      this.uniqueTraders = response.data[0].TOT
    })
    .catch(e => {
      console.error(e)
    })
    axios.get('https://node-api.flipsidecrypto.com/api/v2/queries/6c35d75e-156c-42f8-9d6c-00d3640d631a/data/latest')
    .then(response => {
      this.uniqueSwaps = response.data[0].TOT
    })
    .catch(e => {
      console.error(e)
    })
    axios.get('https://node-api.flipsidecrypto.com/api/v2/queries/5fc05157-e079-4d61-851e-722ebd180235/data/latest')
    .then(response => {
      this.refStaked = response.data[0].NET.toLocaleString('en-US', {useGrouping: true, maximumFractionDigits: 2})
    })
    .catch(e => {
      console.error(e)
    })
    axios.get('https://node-api.flipsidecrypto.com/api/v2/queries/c854671d-fe96-4db3-8029-78869f2169e9/data/latest')
    .then(response => {
      this.refRate = response.data[0].STAKE_RATE.toFixed(2)
    })
    .catch(e => {
      console.error(e)
    })
    axios.get(`https://api.stats.ref.finance/api/24h-volume-variation`)
    .then(response => {
      this.swapVolume = response.data.lastVolumeUSD
    })
    .catch(e => {
      console.error(e)
    })
    
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/chart-apex.scss';
</style>
